<template>
  <card
    :bodyClasses="['body', {'closed': !expanded}]"
    shadow
  >
    <div slot="header" class="row scorecard-header">
      <div class="col-auto d-flex align-items-center" @click="expanded = !expanded">
        <a href="#!" class="avatar rounded-circle">
          <img alt="Image placeholder" v-if="team.avatar" :src="team.avatar.avatar.thumb">
        </a>
      </div>
      <div class="col d-flex align-items-center" >
        <input type="text" v-model="model.teamName" class="hidden-textbox" />
      </div>
      <div class="col-auto text-right d-flex align-items-center justify-content-end">
        <div class="button-area"  v-if="!loading">
          <base-button
            type="success"
            size="sm"
            @click="save"
            v-if="editing"
          >
            Save
          </base-button>
          <base-button
            type="danger"
            size="sm"
            v-if="editing"
            @click="cancel"
          >
            Cancel
          </base-button>
          <base-button
            type="secondary"
            size="sm"
            @click="deleting = true"
            v-if="!editing && !deleting"
          >
            Delete
          </base-button>
          <base-button
            type="danger"
            size="sm"
            @click="deleteTeam"
            v-if="!editing && deleting"
          >
            Confirm Delete
          </base-button>
          <base-button
            type="success"
            size="sm"
            @click="deleting = false"
            v-if="!editing && deleting"
          >
            Cancel
          </base-button>

        </div>
        <div class="loader" v-if="loading">
          Loading
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <i class="fa fa-chevron-down" v-if="!expanded" @click="expanded = !expanded"/>
        <i class="fa fa-chevron-up" v-else @click="expanded = !expanded"/>
      </div>
    </div>
    <div class="row align-items-end d-flex">
      <div class="col-md-6">
        <base-input
          class="mb-0"
          label="Total"
          v-model="model.total"
          input-classes="form-control-alternative"
          type="number"
        />
      </div>
      <div class="col-md-6">
        <base-input
          class="mb-0"
          label="Thru"
          v-model="model.thru"
          input-classes="form-control-alternative"
          type="text"
        />
      </div>
      <div class="col-md-12">
        <base-input
          class="mb-0"
          label="Note"
          v-model="model.note"
          input-classes="form-control-alternative"
          type="text"
        />
      </div>
    </div>
  </card>
</template>
<script>
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'AdminPlayerCard',
  props: {
    team: Object,
  },
  data() {
    return {
      ogState: {
        total: this.team.total,
        thru: this.team.thru,
        teamName: this.team.teamName,
        note: this.team.note,
      },
      model: {
        total: this.team.total,
        thru: this.team.thru,
        teamName: this.team.teamName,
        note: this.team.note,
      },
      edited: false,
      deleting: false,
      expanded: true,
      loading: false,
    };
  },
  computed: {
    editing() {
      if (this.ogState.total === this.model.total
          && this.ogState.thru === this.model.thru
          && this.ogState.teamName === this.model.teamName
          && this.ogState.note === this.model.note) {
        return false;
      }
      return true;
    },
    avatarUrl() {
      if (this.team && this.team.avatar) {
        return this.team.avatar.url;
      }
      return '';
    },
  },
  watch: {
    team: {
      handler() {
        console.log('UPDATED TEAM: ', this.team);
        if (!this.editing) {
          this.model.total = this.team.total;
          this.model.thru = this.team.thru;
          this.model.teamName = this.team.teamName;
          this.model.note = this.team.note;
          this.ogState.total = this.team.total;
          this.ogState.thru = this.team.thru;
          this.ogState.teamName = this.team.teamName;
          this.ogState.note = this.team.note;
        }
      },
      deep: true,
    },
  },
  methods: {
    save() {
      this.axios
        .put(`/liveteams/${this.team.id}`, {
          teamName: this.model.teamName,
          total: this.model.total === '' ? null : this.model.total,
          thru: this.model.thru,
          note: this.model.note,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.ogState.total = response.data.total;
          this.ogState.thru = response.data.thru;
          this.ogState.teamName = response.data.teamName;
          this.ogState.note = response.data.note;
          this.model.total = response.data.total;
          this.model.thru = response.data.thru;
          this.model.teamName = response.data.teamName;
          this.model.note = response.data.note;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    cancel() {
      this.ogState.total = this.team.total;
      this.ogState.thru = this.team.thru;
      this.ogState.teamName = this.team.teamName;
      this.ogState.note = this.team.note;
      this.model.total = this.team.total;
      this.model.thru = this.team.thru;
      this.model.teamName = this.team.teamName;
      this.model.note = this.team.note;
    },
    deleteTeam() {
      this.axios
        .delete(`/liveteams/${this.team.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  .loader{
    text-transform: uppercase;
    font-size: .9rem;
    font-weight: 600;
    opacity: .6;
    padding-right: .5rem;
  }
  .avatar {
    width: 40px;
    height: 40px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .player-card{
    overflow: hidden;
  }
  .status-badge{
    margin-left: 1rem;
    margin-top: .2rem;
  }
  .button-area{
    margin-right: 1rem;
  }
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }

  .checkbox-short{
    padding-left: 2rem;

    .custom-control-label::before{
      left: -2rem;
    }
    .custom-control-label::after{
      left: -2rem;
    }
  }

  .scorecard-header{
    margin: -.5rem -1.5rem;
  }

  .hidden-textbox{
    border: none;
    background: none;
    font-weight: 600;
    line-height: 1.5;
    color: #32325d;
    font-size: 1.0625rem;

    &:focus{
      border: 1px solid #f3f3f3;
    }
  }
</style>
